document.addEventListener('DOMContentLoaded', () => {
  const stickyBtn = document.getElementById('sticky-add-button');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', () => {
    // find the real “Add to cart” button in the product form
    const realBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"]');
    if (realBtn) realBtn.click();
  });
});
